module.exports = __webpack_public_path__ + "static/img/G.1e5cd53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qh/G.png
// module id = fFj/
// module chunks = 0